<template>
    <v-autocomplete :loading="loading" :items="items" :search-input.sync="search" v-model="selected" label="Kunde"
                    cache-items no-data-text="Ingen kunder funnet"/>
</template>

<script>
    import {throttle} from 'lodash';

    export default {
        props: {
            value: Number
        },

        data() {
            return {
                loading: false,
                selected: this.value,
                search: '',
                items: [],
            }
        },

        created() {
            if (this.value) {
                this.loadInitialData();
            }
        },

        watch: {
            search(val) {
                val && this.querySelections(val)
            },
            value() {
                console.log('value change')
                this.selected = this.value;
                this.loadInitialData();
            },
            selected() {
                this.$emit('input', this.selected);
            }
        },

        methods: {
            loadInitialData() {
                this.$http.get(`customers/${this.value}`).then(response => {
                    let it = response.data.data;
                    this.items = [
                        {
                            text: it.name,
                            value: it.id
                        }
                    ];
                }).finally(() => {
                    this.loading = false;
                });
            },
            querySelections: throttle(function (val) {
                this.loading = true;

                let params = {
                    type: 'customers',
                    q: val
                };
                this.$http.get('search', {params}).then(response => {
                    this.items = response.data[0].results.map(it => {
                        return {text: it.title, value: it.id};
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }, 500)
        }
    }
</script>
